import { TFunction } from "i18next";
import * as Yup from "yup";

export const validation = (t: TFunction) => Yup.object({
    product: Yup.string().required(
        t("Errors.Product.Required", "Product is required") ?? "")
        .max(255, t("Errors.Product.MaxLength", "Maximum length for product is 255") ?? ""),
    productType: Yup.number().required(
        t("Errors.ProductType.Required", "Product type is required") ?? "")
        .min(1, t("Errors.ProductType.Value", "Please select a product type") ?? "")
        .max(12, t("Errors.ProductType.Value", "Please select a product type") ?? ""),
    description: Yup.string()
        .required(t("Errors.Description.Required", "Description is required") ?? "")
        .max(4500000, t("Errors.Description.MaxLength", "Maximum length for description is 4500000") ?? ""),
    impacts: Yup.string().max(4500000,
        t("Errors.Impacts.Required", "Maximum length for impacts is 4500000") ?? ""),
    recommendations: Yup.string()
        .max(4500000, t("Errors.Recommendations.MaxLength", "Maximum length for recommendations is 4500000") ?? ""),
    name: Yup.string()
        .max(255, t("Errors.Name.Max", "Maximum length for name is 255") ?? ""),
    email: Yup.string()
        .email(t("Errors.Email.Format", "Must be a valid email") ?? "")
        .max(4096, t("Errors.Email.MaxLength", "Maximum length for email is 4096") ?? ""),
    pgpPublicKey: Yup.string().max(14012, "Maximum length for the pgp public key is 14012"),
    eula: Yup.bool().required(t("Errors.Eula.Required", "You need to accept the conditions.")).isTrue(t("Errors.Eula.Required", "You need to accept the conditions."))
});
